export default __webpack_public_path__ + "static/media/webthrone.232c3f3b.png";